import { render, staticRenderFns } from "./CalendarEventsChart.vue?vue&type=template&id=0c436b7d&scoped=true"
import script from "./CalendarEventsChart.vue?vue&type=script&lang=js"
export * from "./CalendarEventsChart.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventsChart.vue?vue&type=style&index=0&id=0c436b7d&prod&lang=scss"
import style1 from "./CalendarEventsChart.vue?vue&type=style&index=1&id=0c436b7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c436b7d",
  null
  
)

export default component.exports